import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyLorealMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="lorealGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#FFE4E1", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#FFC0CB", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#FF69B4", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <rect width={width} height={height} fill="url(#lorealGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {Array.from({ length: 18 }).map((_, i) =>
          Array.from({ length: 24 }).map((_, j) => {
            const x = -360 + i * 40;
            const y = -480 + j * 40;
            return (
              <circle
                key={`dermal-${i}-${j}`}
                cx={x}
                cy={y}
                r={8}
                fill="none"
                stroke="#FF69B4"
                strokeWidth={1}
                opacity={0.15}
              />
            );
          })
        )}
        {Array.from({ length: 18 }).map((_, r) => (
          <circle
            key={`beauty-${r}`}
            cx={0}
            cy={0}
            r={(r + 1) * 22}
            fill="none"
            stroke="#FFFFFF"
            strokeWidth={r % 3 === 0 ? 2 : 1.5}
            opacity={0.3 - r * 0.012}
          />
        ))}
        <circle cx={0} cy={0} r={55} fill="none" stroke="#FF69B4" strokeWidth={3} opacity={0.6} />
        <circle cx={0} cy={0} r={38} fill="#FFC0CB" opacity={0.4} />
      </g>
    </svg>
  );
}
